import styled from "styled-components";

export const StyledList = styled.ul`
    ${({ customStyle }) => customStyle && customStyle};
`;
